import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Message from 'components/Message';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import { barHeightPercent } from './AdjustsCreditsPanel.constants';
import { useAdjustsCreditsDemandAnimation } from './AdjustsCreditsDemandIllustration.hooks';
import messages from './AdjustsCreditsPanel.messages';
import './AdjustsCreditsDemandIllustration.scss';

const { block, element } = bem('adjusts-credits-demand-illustration');

const DemandBar = ({ height, isActive, labelMessage }) => (
  <div className={element('bar-group')}>
    <div className={element('bar-track')}>
      <div
        className={classNames(element('bar'), {
          [element('bar', { active: true })]: isActive,
        })}
        style={{ height: barHeightPercent(height) }}
      />
    </div>
    <Message as="p" className={element('bar-label')} message={labelMessage} />
  </div>
);

DemandBar.propTypes = {
  height: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  labelMessage: intlMessage.isRequired,
};

const AdjustsCreditsDemandIllustration = () => {
  const prefersReducedMotion = useMemo(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    []
  );

  const { creditActive, creditHeight, demandActive, demandHeight } = useAdjustsCreditsDemandAnimation({
    prefersReducedMotion,
  });

  return (
    <div aria-hidden className={block()}>
      <div className={element('chart')}>
        <DemandBar
          height={demandHeight}
          isActive={demandActive}
          labelMessage={messages.demandIllustrationDemandLabel}
        />
        <DemandBar
          height={creditHeight}
          isActive={creditActive}
          labelMessage={messages.demandIllustrationCreditLabel}
        />
      </div>
    </div>
  );
};

export default AdjustsCreditsDemandIllustration;
